import React from "react";
import "./css/greivance.css";
import { Container, Typography, Button, CircularProgress } from "@material-ui/core";
import AlertDiv from "../Components/Registration/Forms/AlertDiv";
import CallToAction from "@material-ui/icons/CallToAction";
import { orange, green, red, grey } from "@material-ui/core/colors";
import { GetData, PostData } from "../api/service";
import { message } from "antd";

/**
 * Public payment page for a staff-raised payment request.
 * Route: /pay/:token  (see ONLINE_PAYMENT_REQUEST_PLAN.md)
 * Self-contained container; does not modify any existing component.
 */
export default function PayRequest(props) {
  const token = props.match.params.token;

  const [summary, setSummary] = React.useState(null);
  const [isLoaded, setIsLoaded] = React.useState(false);
  const [notFound, setNotFound] = React.useState(false);
  const [paymentData, setPaymentData] = React.useState(null);
  const [isPaying, setIsPaying] = React.useState(false);

  function loadSummary() {
    GetData(`/paymentrequest/view/${token}`).then((resp) => {
      if (resp && resp.status === true) {
        setSummary(resp);
        setIsLoaded(true);
      } else {
        setNotFound(true);
        setIsLoaded(true);
      }
    });
  }

  React.useEffect(() => {
    loadSummary();
    // eslint-disable-next-line
  }, []);

  function handlePayNow() {
    setIsPaying(true);
    PostData(`/paymentrequest/get-payment-string`, { token: token }).then((resp) => {
      setIsPaying(false);
      if (resp.status === true) {
        if (resp.redirect === true) {
          window.location.href = `/paymentresponse-request?status=Success&token=${token}`;
        } else if (
          resp.data &&
          resp.data.action &&
          resp.data.encRequest &&
          resp.data.access_code
        ) {
          setPaymentData(resp.data);
        } else {
          message.error("Could not initialise payment. Please try again.");
        }
      } else {
        message.error(resp.status_text || "Unable to start payment.");
      }
    });
  }

  const statusColors = {
    PAID: green,
    PENDING: orange,
    FAILED: red,
    EXPIRED: grey,
    CANCELLED: grey,
  };

  return (
    <div>
      <Container>
        <br />
        <br />
        <div className="container">
          <div className="reg-form">
            <div className="top-bar"></div>
            <div className="form-contents">
              <h3
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <div style={{ marginLeft: 10, fontWeight: 700 }}>
                  Online Fees Payment
                  <br />
                  <div style={{ fontSize: 16 }}>Pragjyotish College</div>
                </div>
              </h3>
              <hr />

              {!isLoaded && (
                <div style={{ textAlign: "center", padding: 30 }}>
                  <CircularProgress />
                </div>
              )}

              {isLoaded && notFound && (
                <AlertDiv back={red[100]} border={red[400]}>
                  <Typography variant="body2">
                    This payment link is invalid or no longer available.
                  </Typography>
                </AlertDiv>
              )}

              {isLoaded && summary && (
                <div>
                  <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 16 }}>
                    <tbody>
                      <tr>
                        <td style={{ padding: "4px 8px", fontWeight: 700 }}>Name</td>
                        <td style={{ padding: "4px 8px" }}>{summary.name}</td>
                      </tr>
                      <tr>
                        <td style={{ padding: "4px 8px", fontWeight: 700 }}>Course</td>
                        <td style={{ padding: "4px 8px" }}>
                          {summary.course}
                          {summary.semester ? ` (Sem ${summary.semester})` : ""}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ padding: "4px 8px", fontWeight: 700 }}>Email</td>
                        <td style={{ padding: "4px 8px" }}>{summary.email}</td>
                      </tr>
                    </tbody>
                  </table>

                  <Typography variant="body2" style={{ fontWeight: 700, marginBottom: 4 }}>
                    Payment Details
                  </Typography>
                  <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 16 }}>
                    <tbody>
                      {(summary.sub_items || []).map((it, i) => (
                        <tr key={i}>
                          <td style={{ padding: "4px 8px", borderBottom: "1px solid #eee" }}>
                            {it.sm_head}
                          </td>
                          <td
                            style={{
                              padding: "4px 8px",
                              textAlign: "right",
                              borderBottom: "1px solid #eee",
                            }}
                          >
                            &#8377; {it.sm_amount}
                          </td>
                        </tr>
                      ))}
                      <tr>
                        <td style={{ padding: "4px 8px", fontWeight: 700 }}>Total</td>
                        <td style={{ padding: "4px 8px", textAlign: "right", fontWeight: 700 }}>
                          &#8377; {summary.amount}
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  {summary.payment_status === "PAID" ? (
                    <AlertDiv back={green[100]} border={green[400]}>
                      <Typography variant="body2">
                        This payment is already completed. Receipt No:{" "}
                        <b>{summary.receipt_no}</b>.
                      </Typography>
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        style={{ marginTop: 8 }}
                        onClick={() =>
                          (window.location.href = `/paymentresponse-request?status=Success&token=${token}`)
                        }
                      >
                        View Receipt
                      </Button>
                    </AlertDiv>
                  ) : summary.payment_status === "PENDING" ? (
                    <div>
                      <AlertDiv back={orange[100]} border={orange[400]}>
                        <Typography variant="body2">
                          Click <b>Pay Now</b> to pay securely via the payment
                          gateway. After a successful payment, a fees receipt is
                          generated automatically.
                        </Typography>
                      </AlertDiv>

                      {!paymentData && (
                        <Button
                          variant="contained"
                          color="primary"
                          type="button"
                          onClick={handlePayNow}
                          disabled={isPaying}
                          style={{ marginTop: 12 }}
                        >
                          <CallToAction /> &nbsp;
                          {isPaying ? "Please wait..." : `Pay Now ₹ ${summary.amount}`}
                        </Button>
                      )}

                      {paymentData && (
                        <form method="post" action={paymentData.action}>
                          <input type="hidden" name="encRequest" value={paymentData.encRequest} />
                          <input type="hidden" name="access_code" value={paymentData.access_code} />
                          <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                            style={{ marginTop: 12 }}
                          >
                            <CallToAction /> &nbsp; Proceed To Pay &#8377; {paymentData.amount}
                          </Button>
                        </form>
                      )}
                    </div>
                  ) : (
                    <AlertDiv
                      back={(statusColors[summary.payment_status] || grey)[100]}
                      border={(statusColors[summary.payment_status] || grey)[400]}
                    >
                      <Typography variant="body2">
                        This payment link is {String(summary.payment_status).toLowerCase()} and can
                        no longer be paid. Please contact the college office.
                      </Typography>
                    </AlertDiv>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
}
